

import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import apiConfig from "../../../apiConfig"; 

const BulkProductUpload = () => {
  const [file, setFile] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      readExcel(selectedFile);
    }
  };

  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(firstSheet);
      setProducts(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleUpload = async () => {
    setLoading(true);
    setError(null); 
    const formData = new FormData();
    formData.append("file", file); 

    try {
      const response = await axios.post(
        `${apiConfig.baseUrl}/admin/upload-bulk-products`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", 
          },
        }
      );
    
      setProducts([]);
      setFile(null);
    } catch (err) {
      console.error("Error uploading products:", err);
      alert("Failed to upload products. Please try again.");
      setError("Failed to upload products");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bulk-upload">
      <h1>Bulk Product Upload</h1>
      <input
        type="file"
        name="file"
        accept=".xlsx, .xls"
        onChange={handleFileChange}
      />
      {products.length > 0 && (
        <div>
          <h2>Preview Products</h2>
          <table>
            <thead>
              <tr>
                {Object.keys(products[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => (
                <tr key={index}>
                  {Object.values(product).map((value, idx) => (
                    <td key={idx}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={handleUpload} disabled={loading}>
            {loading ? "Uploading..." : "Upload Products"}
          </button>
        </div>
      )}
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default BulkProductUpload;
